function tagManager_impression (objects, list, counter) {

    if (typeof counter == 'undefined') {
        counter = 0;
    }

    if (typeof dataLayer == 'undefined') {
        tagManager_impression(objects, list, counter + 1);
    } else if (counter < 3) {
        // console.log('impressions', objects);

        dataLayer.push({ ecommerce: null });

        var ga4objects = [];
        for (var i = 0; i < objects.length; i++) {
            ga4objects.push({
                item_id: objects[i].id,
                item_name: objects[i].name,
                currency: "EUR",
                discount: 0,
                index: i + 1,
                item_brand: objects[i].brand,
                item_category: objects[i].category,
                item_list_id: objects[i].list,
                item_list_name: objects[i].list,
                item_variant: "",
                price: objects[i].price,
                quantity: 1
            });
        }

        dataLayer.push({
            'event': 'view_item_list',
            'ecommerce': {
                'items': ga4objects,
                'item_list_id': list,
                'item_list_name': list
            }
        });
    }
}

function tagManager_ProductClick(list, item) {

    if (env == 'dev') {
        console.log('select_item', list, item);
    }

    var itemga4 = {
        item_id: item.id,
        item_name: item.name,
        affiliation: "",
        coupon: "",
        currency: "EUR",
        discount: 0,
        index: 0,
        item_brand: item.brand,
        item_category: item.category,
        item_list_id: item.list,
        item_list_name: item.list,
        item_variant: "",
        price: item.price,
        quantity: 1
    };

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
        event: "select_item",
        ecommerce: {
            item_list_id: list,
            item_list_name: list,
            items: [itemga4]
        }
    });
}

function tagManager_click (objects, list, counter) {

    if (typeof counter == 'undefined') {
        counter = 0;
    }

    if (typeof dataLayer == 'undefined') {
        tagManager_click (objects, list, counter + 1);
    } else if (counter < 3) {
        // console.log('list', list, 'click', objects);

        dataLayer.push({ ecommerce: null });

        var ga4objects = [];
        for (var i = 0; i < objects.length; i++) {
            ga4objects.push({
                item_id: objects[i].id,
                item_name: objects[i].name,
                currency: "EUR",
                discount: 0,
                index: i + 1,
                item_brand: objects[i].brand,
                item_category: objects[i].category,
                item_list_id: objects[i].list,
                item_list_name: objects[i].list,
                item_variant: "",
                price: objects[i].price,
                quantity: 1
            });
        }

        dataLayer.push({
            'event': 'select_item',
            'ecommerce' : {
                'items': ga4objects,
                'item_list_id': list,
                'item_list_name': list
            }
        });
    }
}

function tagManager_details (objects, list, counter) {

    if (typeof counter == 'undefined') {
        counter = 0;
    }

    if (typeof dataLayer == 'undefined') {
        tagManager_details(objects, list, counter + 1);
    } else if (counter < 3) {
        // console.log('details', objects);

        dataLayer.push({ ecommerce: null });

        var ga4objects = [];
        for (var i = 0; i < objects.length; i++) {
            ga4objects.push({
                item_id: objects[i].id,
                item_name: objects[i].name,
                currency: "EUR",
                discount: 0,
                index: i + 1,
                item_brand: objects[i].brand,
                item_category: objects[i].category,
                item_list_id: list,
                item_list_name: list,
                item_variant: "",
                price: objects[i].price,
                quantity: 1
            });
        }

        dataLayer.push({
            'event': 'view_item',
            'ecommerce': {
                currency: "EUR",
                value: objects[0].price,
                items: ga4objects
            }
        });
    }
}

function tagManager_addToCart (objects, counter) {

    if (typeof counter == 'undefined') {
        counter = 0;
    }

    if (typeof dataLayer == 'undefined') {
        tagManager_addToCart(objects, counter + 1);
    } else if (counter < 3) {
        console.log('addToCart', objects);

        dataLayer.push({ ecommerce: null });

        var ga4objects = [];
        var ga4total = 0;
        for (var i = 0; i < objects.length; i++) {
            ga4objects.push({
                item_id: objects[i].id,
                item_name: objects[i].name,
                currency: "EUR",
                discount: 0,
                index: i + 1,
                item_brand: objects[i].brand,
                item_category: objects[i].category,
                item_list_id: "",
                item_list_name: "",
                item_variant: "",
                price: objects[i].price,
                quantity: objects[i].quantity
            });
            ga4total = parseFloat(ga4total) + (parseFloat(objects[i].price) * parseFloat(objects[i].quantity));
        }

        dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
                currency: "EUR",
                value: ga4total,
                items: ga4objects
            }
        });
    }
}

function tagManager_removeFromCart (objects, counter) {

    if (typeof counter == 'undefined') {
        counter = 0;
    }

    if (typeof dataLayer == 'undefined') {
        tagManager_removeFromCart(objects, counter + 1);
    } else if (counter < 3) {
        // console.log('removeFromCart', objects);

        dataLayer.push({ ecommerce: null });

        var ga4objects = [];
        for (var i = 0; i < objects.length; i++) {
            ga4objects.push({
                item_id: objects[i].id,
                item_name: objects[i].name,
                currency: "EUR",
                discount: 0,
                index: i + 1,
                item_brand: objects[i].brand,
                item_category: objects[i].category,
                item_list_id: "",
                item_list_name: "",
                item_variant: "",
                price: objects[i].price,
                quantity: objects[i].quantity
            });
        }

        dataLayer.push({
            'event': 'remove_from_cart',
            currency: "EUR",
            value: parseFloat(parseFloat(objects[0].price) * parseFloat(objects[0].quantity)),
            items: ga4objects
        });
    }
}

function tagManager_checkout (step, objects, option, parameters, counter) {

    if (typeof counter == 'undefined') {
        counter = 0;
    }

    if (typeof dataLayer == 'undefined') {
        tagManager_checkout(step, objects, option, parameters, counter + 1);
    } else if (counter < 3) {
        // console.log('checkout', step, objects, option);

        if (typeof option == 'undefined') {
            option = '';
        }

        dataLayer.push({ ecommerce: null });

        var ga4objects = [];
        var total = 0;
        for (var i = 0; i < objects.length; i++) {
            ga4objects.push({
                item_id: objects[i].id,
                item_name: objects[i].name,
                currency: "EUR",
                discount: 0,
                index: i + 1,
                item_brand: objects[i].brand,
                item_category: objects[i].category,
                item_list_id: "",
                item_list_name: "",
                item_variant: "",
                price: objects[i].price,
                quantity: objects[i].quantity
            });

            total = total + parseFloat(parseFloat(objects[i].price) * parseFloat(objects[i].quantity))
        }

        var ga4Event = '';
        if (step == 1) {
            ga4Event = 'view_cart';
            dataLayer.push({
                'event': ga4Event,
                'ecommerce': {
                    currency: "EUR",
                    value: parseFloat(total),
                    items: ga4objects
                }
            });
        } else if (step == 2) {
            ga4Event = 'begin_checkout';
            dataLayer.push({
                'event': ga4Event,
                'ecommerce': {
                    currency: "EUR",
                    value: parseFloat(total),
                    items: ga4objects
                }
            });
        } else if (step == 3) {
            ga4Event = 'add_shipping_info';
            dataLayer.push({
                'event': ga4Event,
                'ecommerce': {
                    currency: "EUR",
                    value: parseFloat(total),
                    items: ga4objects,
                    shipping_tier: parameters.shipping_tier,
                    coupon: parameters.coupon
                }
            });
        } else if (step == 4) {
            ga4Event = 'add_payment_info';
            dataLayer.push({
                'event': ga4Event,
                'ecommerce': {
                    currency: "EUR",
                    value: parseFloat(total),
                    items: ga4objects,
                    payment_type: parameters.payment_type,
                    coupon: parameters.coupon
                }
            });
        }
    }
}

function tagManager_checkoutOption(step, checkoutOption, counter) {

    // if (typeof counter == 'undefined') {
    //     counter = 0;
    // }
    //
    // if (typeof dataLayer == 'undefined') {
    //     tagManager_checkoutOption(step, checkoutOption, counter + 1);
    // } else if (counter < 3) {
    //     // console.log('checkoutOption', step, checkoutOption);
    //
    //     if (typeof checkoutOption == 'undefined') {
    //         checkoutOption = '';
    //     }
    //
    //     dataLayer.push({ ecommerce: null });
    //     dataLayer.push({
    //         'event': 'checkoutOption',
    //         'currencyCode': 'EUR',
    //         'ecommerce': {
    //             'checkout_option': {
    //                 'actionField': {'step': step, 'option': checkoutOption}
    //             }
    //         }
    //     });
    // }
}

function tagManager_purchase(id, objects, affiliation, revenue, tax, shipping, coupon, couponCode, counter) {

    if (typeof counter == 'undefined') {
        counter = 0;
    }

    if (typeof dataLayer == 'undefined') {
        tagManager_purchase(id, objects, affiliation, revenue, tax, shipping, coupon, couponCode, counter + 1);
    } else if (counter < 3) {
        // console.log('purchase', id, objects, affiliation, revenue, tax, shipping, coupon);

        if (typeof affiliation == 'undefined') {
            affiliation = '';
        }

        if (typeof coupon == 'undefined') {
            coupon = '';
        }

        // dataLayer.push({ ecommerce: null });
        // dataLayer.push({
        //     'event': 'purchase',
        //     'ecommerce': {
        //         'currencyCode': 'EUR',
        //         'purchase': {
        //             'actionField': {
        //                 'id': id,
        //                 'affiliation': affiliation,
        //                 'revenue': revenue,
        //                 'tax': tax,
        //                 'shipping': shipping,
        //                 'coupon': coupon
        //             },
        //             'products': objects
        //         }
        //     }
        // });

        var ga4objects = [];
        for (var i = 0; i < objects.length; i++) {
            ga4objects.push({
                item_id: objects[i].id,
                item_name: objects[i].name,
                currency: "EUR",
                discount: 0,
                index: i + 1,
                item_brand: objects[i].brand,
                item_category: objects[i].category,
                item_list_id: "",
                item_list_name: "",
                item_variant: "",
                price: objects[i].price,
                quantity: objects[i].quantity
            });
        }

        dataLayer.push({
            'event': 'purchase',
            currency: "EUR",
            value: revenue,
            items: ga4objects,
            'transaction_id': id,
            'affiliation': affiliation,
            'tax': tax,
            'shipping': shipping,
            'coupon': coupon
        });
    }
}